
import React, { useState } from 'react';
import PageBox from '../../components/PageBox';
import AboutMenu from '../../components/AboutMenu';
import AboutTitle from '../../components/AboutTitle';
import './index.less'
import contact from "../../static/images/contact.jpg"
import erweima from "../../static/images/erweima.jpg"
export default function App() {
  return (
    <>
      <PageBox useBanner={true}>
        <div className='aboutBanner'></div>
        <AboutMenu active={'7'} />
        <AboutTitle name={'联系我们'} english={'CONTACT'}  />
        <div className='aboutImg'><img src={contact} />
          <div className='aboutImg-top'>
            <h1>公司地址·深圳</h1>
            <p>公司地址：深圳市福田区上步南路锦峰大厦22B</p>
          </div>
          <div className='aboutImg-center'>
            <div style={{width:'80%'}}>
              <h3>联系我们</h3>
              <p>24小时服务热线，全天候为您提供业务咨询服务</p>
              <div className='aboutImg-list'>联系电话：<strong style={{fontSize:'20px',color:'#3057d6'}}>0755-83629950</strong></div>
              <div className='aboutImg-list'>E-mail：td@szyd11.com</div>
            </div>
            {/* <div>
              <h3>扫描关注公司官网</h3>
              <p>微信扫描二维码，实时关注公司动态</p>
              <div style={{paddingTop:'15px'}}><img src={erweima} /></div>
            </div> */}
          </div>
        </div>
      </PageBox>
    </>
    
  );
}
